import React from 'react';
import { Security } from '@browsing/icons';
import { LazyPreliminaryOrder } from '@browsing/overlays';

import { useCart } from '@client/lib/cart/hooks';

export const PreliminaryOrder = () => {
    const [, { onAllItemsRemove }] = useCart();

    return (
        <LazyPreliminaryOrder
            icon={<Security width="25px" height="25px" />}
            onCartItemsRemoved={onAllItemsRemove}
        />
    );
};
